<template>
    <div>
        <div class="col-12 pb-5 mb-4" v-if="pageloader">
            <img src="../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
        </div>
        <div v-else class="ml-3 mr-3">
            <div class=" no-gutters mt-4 "  >
                <div class="col-lg-12">
                    <div class="viewcard d-flex justify-content-between">
                        <div class="d-flex">
                            <div class="d-flex pl-3 pr-3 trendingg">
                                <p class="ml-1  fittocenter black60 proximanova-semibold fontsize12">TRENDING</p>
                            </div>
                            <div class="d-flex ml-lg-3 ml-1 ">
                                <p class="fittocenter viewcount proximanova">{{totalProfileViews}}</p>
                                <p class="ml-1  fittocenter proximanova-semibold fontsize12">Profile Viewers in last 90 days</p>
                            </div>
                        </div>
                    </div>
                    <div class="viewcard ">
                        <profile-view-chart></profile-view-chart>
                    </div>
                    <nav class="nav d-flex justify-content-between mobviewItems  mt-4" id="nav">
                        <div class="proximanova-semibold fontsize12 blue">
                            <div class=" no-gutters">
                                <ul class="nav nav-tabs p-1">
                                    <li class="nav-item" > 
                                        <a href="#" class="navitem" id="people"                                                            
                                        >All Viewers</a>
                                    </li>
                                    <!--<li class="nav-item" > 
                                        <a href="#" class="navitem"
                                            :class="{'list-text-colorsub':activeClass == 'people'}" id="people"                                                            
                                        >All Viewers</a>
                                    </li>
                                    <li class="nav-item d-flex ml-3" > 
                                        <img src="../assets/Company_Icon.svg" class="navicon" alt="">
                                        <a href="#"  class="navitem" :class="{'list-text-colorsub':activeClass == 'company'}" id="company"                                                            
                                        >Company Name</a>
                                    </li>
                                    <li class="nav-item d-flex ml-3"> 
                                        <img src="../assets/Company_Icon.svg" class="navicon" alt="">
                                        <a href="#" class="navitem" :class="{'list-text-colorsub':activeClass == 'job'}" id="job"                                                            
                                        >Group Name</a>
                                    </li>
                                    <li class="nav-item d-flex ml-3"> 
                                        <img src="../assets/Company_Icon.svg" class="navicon" alt="">
                                        <a href="#" class="navitem" :class="{'list-text-colorsub':activeClass == 'product'}" id="product"                                                            
                                        >Who work's at Syntrino</a>
                                    </li>      -->
                                </ul>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
            <div class="col-lg-12 col-md-12 viewercards row no-gutters mt-4" v-if="profileViews.length > 0">
                <!-- <div class="col-6" v-if="trailAccounttype !=='Y' || rmainingDaysforEndDate <= 0"> -->
                <div class="col-6" v-if="entitlements.viewedPercentageGraph !== 'Y'">
                    <div class="card premium p-3 mb-2 ml-1 text-center">
                        <div class="mt-2">
                            <img src="../assets/premiumLock.svg" alt="premium" class="">
                        </div>
                        <div class="d-flex flex-column">
                            <span class="proximanova-semibold black fontsize14">Unlock your profile views with <br> Premium account</span>
                        </div>
                        <div class="d-flex premiumuserimg text-center mt-1">
                            <span v-for="(prem, index) in premiumcardList" :key="index">
                                <img :src="prem.prfpiclink" v-if="prem.prfpiclink" id="followImage" class="rounded-circle" alt="profilepic">
                                <div v-else class="othercircles rounded-circle" :class="prem.fulname.charAt(0)" oncontextmenu="return false;">
                                    <span class="fontsize10 proximanova" alt="">{{prem.fulname.charAt(0)}}</span>
                                </div>
                            </span>
                            <span v-if="premiumcardList.length < 1" class="d-flex">
                                <div class="blackcircle rounded-circle"></div>
                            </span>
                            <div class="blackcircle rounded-circle" v-if="remainingCount>0">
                                <span class="fontsize10 proximanova" alt="">+{{remainingCount}}</span>
                            </div>
                        </div>
                        <div class="mt-2 p-2 pb-1d-flex">
                            <p class="proximanova-semibold fontsize10 black60 ml-1" v-if="premcardname">{{premcardname}} </p>
                            <p class="proximanova-semibold fontsize10 black60 ml-1 mt-1" v-else>Work-Notion</p>
                        </div>
                        <div class="mb-2">
                            <button type="button" class="btn followbtn borderradius20 mouseoverbtn2 proximanova-semibold fontsize16 backgroundcolorblack white bold" @click="TryPremium">Try Premium</button>
                        </div>
                        <div class="mt-1">
                            <p class="proximanova-semibold fontsize10 black60">Free for a month</p>
                        </div>
                    </div>
                </div>
                <div class="col-6" v-for="(record, index) in profileViews" :key="index">
                    <div class="card p-3 mb-2 text-center ml-1" >
                        <div class="mt-2">
                            <!-- <img src="../assets/Profile_placehlder.svg" alt="" class="viewprofimg" v-if="!record.prfpiclink"> -->
                            <div v-if="!record.prfpiclink" id="profImage" class="viewprofimg text-center white fontsize14 rounded-circle white mx-auto" :class="record.fulname.charAt(0)">
                                <p class="white fontsize14  text-uppercase">{{record.fulname.charAt(0)}}</p>
                            </div>
                            <img v-else class="viewprofimg loadingBgImg" :src="record.prfpiclink" @error="record.prfpiclink = null" alt="profilepic">
                        </div>
                        <div class="d-flex flex-column">
                            <span class="proximanova-semibold fontsize14 black p-1 username" @click="selectedUser(record.aliasLink)" >{{record.fulname}}</span>
                            <span class="proximanova black fontsize14 ">{{record.rlenme}}</span>
                            <span class="proximanova fontsize12 black80 d-flex flex-wrap mx-auto">
                                <span v-if="record.compname">{{record.compname}}</span>
                                <span v-if="record.citynme"> , {{record.citynme}} </span>
                                <span v-if="record.countrynme" class="mx-auto"> , {{record.countrynme}}</span>
                            </span>
                        </div>
                        <div class="mt-3">
                            <p class="proximanova-semibold fontsize10 black60">Found you in via WORKNOTION search</p>
                        </div>
                        <div class="p-2">
                            <p class="proximanova-semibold fontsize12 black">{{new Date(record.createdatetimestamp) | moment("from", "now", true)}}</p>
                        </div>
                        <div class="mb-2">
                            <button type="button" :disabled="record.disablefollowBtn" v-if="record.followflag == 'N'" class="btn mouseoverbtn2 followbtn borderradius20 proximanova-semibold fontsize16 black80" @click="followUser(record.profid, index, record)">Follow</button>
                            <button type="button" :disabled="record.disablefollowBtn" v-if="record.followflag == 'Y'" class="btn mouseoverbtn2 followbtn borderradius20 backgroundcolor3 proximanova-semibold fontsize16 white" @click="unfollowUser(record.profid, index, record)">UnFollow</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class=" no-gutters mt-4 "  v-if="profileViews.length < 1">
                <div class="col-lg-12">
                    <div class="viewcard">
                        <div class="p-5 mt-3 mb-3 d-flex flex-column text-center">
                            <img src="../assets/no_video.svg" alt="novideo" class="img-md-fluid img-sm-fluid no-video pl-4 pr-4 pl-md-5 pr-md-5 pb-4">
                            <span class="oopsnext proximanova">No Records Found</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal>
    </div>
</template>
<script>
import httpuserprofile from "../js/http-userprofile.js"
import router from '../router';
import profileViewChart from '../components/ProfileViewChart.vue'
import APIerrorModal from '../components/APIerrorpopup.vue'
import sessionUtils from '@/js/session-util.js'
export default {
    components:{
        profileViewChart,
        APIerrorModal
    },
    data(){
        return{
            //profile views
            profileViews : [],
            premcardname : null,
            premiumcardList : [],
            remainingCount : 0,
            totalProfileViews : 0,
            trailAccounttype : null,
            pageloader : true,
            currentPlanDetails : null,
            entitlements : null,
            displayAPIerrorModal : false,
        }
    },
    methods : {
        closeAPIerrorModal(){
            this.displayAPIerrorModal = false;
        },
        // this will invoke after click on user profile picture / user name on video card
        // naviaget to seperate page where user can able to see the selected user information
        selectedUser(id){
            this.activeField = false;
            this.$store.state.selectedUser = id;      
            // if(sessionUtils.getUserId() === id){
            //     router.push({
            //     name : 'welcome'
            //     }) 
            // }else{
                this.$router.push({name: 'wn', params: { id: this.$store.state.selectedUser}});
            // }    
        },
        // initial rendering the profile view data
        // set the data based on user entitlements
        getProfileViews : function() {
            console.log("clling")
            httpuserprofile.get('/userprofile/userviewedList?profileId='+this.currentUserProfileId+'&limit=20')
            .then((response) => {
                console.log(response)
                // if(response.data.totalRecordsFound > 6 && response.data.totalRecordsFound > response.data.list.length) {
                // if(response.data.trailAccountFlag !== 'Y' || response.data.rmainingDaysforEndDate <= 0){
                if(response.data && response.data.list && response.data.list.length>0){
                    response.data.list.forEach(function(d){   
                        d.disablefollowBtn = false;          
                    }) 
                }
                if(this.entitlements.viewedPercentageGraph !== 'Y'){ 
                    console.log("none of the selecetd")
                    let instance = response.data.list;
                    for(var i = 0; i < instance.length; i++) {
                        if(i < 3){
                            this.profileViews.push(instance[i])
                        }else{
                            if(i>=3 && i < 6){
                                this.premiumcardList.push(instance[i]);
                                this.remainingCount = response.data.totalRecordsFound - 6
                            }
                        }
                    }
                    if(this.premiumcardList.length > 0) {
                        this.premcardname = this.premiumcardList[0].fulname +' and more ...' 
                    }
                }else{
                    console.log("in trail/premium verison")
                    this.trailAccounttype = response.data.trailAccountFlag;
                    this.profileViews = response.data.list
                }
                this.totalProfileViews = response.data.totalRecordsFound
                this.pageloader = false
                // if(response.data.rmainingDaysforEndDate !== null) {
                //     this.rmainingDaysforEndDate = response.data.rmainingDaysforEndDate
                //     this.$store.state.remainingDays = response.data.rmainingDaysforEndDate
                // }else{
                //     this.$store.state.remainingDays = null
                // }
                // if(response.data.trailAccountFlag !== null) {
                //     this.$store.state.trailAccountFlag = response.data.trailAccountFlag
                // }else{
                //     this.$store.state.trailAccountFlag = null
                // }
            }).catch((e) => {
                console.log(e)
                this.pageloader = false
            })
        },
        //this will invoke after click on follow button on user card to follow user
        followUser : function(profId, index, user) {
            user.disablefollowBtn = true;
            httpuserprofile.post("/userprofile/saveFollowing?profileId="+this.currentUserProfileId+"&followingId="+profId)
            .then(response => {
                console.log(response)
                user.disablefollowBtn = false;
                this.profileViews[index].followflag = 'Y'
            }).catch((e) => {
                console.log(e)
                user.disablefollowBtn = false;
                this.displayAPIerrorModal = true;
            })
        },
        //this will invoke after click on unfollow button on user card to unfollow user
        unfollowUser : function(profId, index, user) {
            user.disablefollowBtn = true;
            httpuserprofile.delete("/userprofile/unfollow?profileId="+this.currentUserProfileId+"&followingId="+profId)
            .then(response => {
                console.log(response)
                user.disablefollowBtn = false;
                this.profileViews[index].followflag = 'N'
            }).catch((e) => {
                console.log(e)
                user.disablefollowBtn = false;
                this.displayAPIerrorModal = true;
            })
        },
        // this will invoke after click on trypremium button
        // navigate user to plan selection screen
        TryPremium : function() {
            router.push({
                name : 'Premium'
            })
        },
        // fetch current plan details
        getCurrentPlan(){
            httpuserprofile.get('/userprofile/getCurrentSubscriptionPlan?profileId='+this.currentUserProfileId+'&status=y')
            .then((response) => {
                console.log("current plan : ", response)
                if(response.data.length > 0){
                    this.currentPlanDetails = response.data[0];
                }
                console.log("current plan details : ", this.currentPlanDetails)
            }).catch((e) => {
                console.log(e.response)
            })
        },
        getcurrentUser(){
            this.currentUserProfileId = sessionUtils.getUserProfileId();
            if(this.currentUserProfileId){
            this.getCurrentPlan()
            this.getProfileViews()
            }else{
                this.pageloader = false
            }
        },
    },
    created(){        
        window.scrollTo(0, 0);
        this.currentUserId = sessionUtils.getUserId();
        this.entitlements = JSON.parse(localStorage.getItem('entitlements'))
        this.getcurrentUser()
    },
}
</script>
<style scoped>
html,
body,
.grid {
    height: 100%;
    width: 100%;
}
.loadingBgImg{
  background: transparent url('../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.viewercards{
    padding-left: 0 !important;
    padding-right: 0 !important;
}
.header {
    position: fixed;
    width: 100%;
    z-index: 10;
    background: #ffffff;
    border-bottom: 2px solid rgba(219, 219, 219,1);
}
.nav-tabs {
    border-bottom: none !important;
}
.card-header {
    padding: 5px 10px 5px 10px;
    margin-bottom: 0;
    border: 1px solid #d9dce1;
    opacity: 0.6;
    border-radius: 8px;
}
.premiumuserimg{
    margin: 0 auto;
}
.card-header1 {
    border: 1px solid #d9dce1;
    opacity: 0.6;
    border-radius: 8px;
}
.nav{
    background-color: #f0f2f5  !important; 
    border-radius: 8px !important;
}
.navbar {
    padding: 0px 0px 0px 0px !important;
    z-index: 100;
}
.nav{
    flex-wrap: unset !important;
}
.username{
    cursor: pointer;
}
.list-text-color {
    color: #0078ff;
    /* font-family: "Proxima Nova"  !important; */
    /* font-size: 16px; */
    font-weight: bold;
    letter-spacing: 0;
    white-space: nowrap;
}
.list-text-colorsub{
    color: black !important;
    font-weight: bold;
    letter-spacing: 0;
    white-space: nowrap;
}
.navitem{
    white-space: nowrap;
}
.border-tab {
    border-bottom-style: solid;
    border-bottom-color: #0078ff;
    /* margin-left: 10px;
    margin-right: 10px; */
}
#followImage{
    width: 30px;
    height: 30px;
    padding: .5px;
    transform: scale(1.2)  !important;
    border: 1px solid #1F1F1F;
}
.othercircles {
    color: white;
    transform: scale(1.2)  !important;
    width: 30px !important;
    height: 30px !important;
}
.blackcircle{
    background: black;
    color: white;
    transform: scale(1.2)  !important;
    width: 30px !important;
    height: 30px !important;
}
.no-video {
    width: 50%;
    align-self: center;
  }
.premiumcount{
    font-size: 10px;
}
.pageloader {
  width: 7%;
  margin-top: 15%;
  margin-left: 46%;
}
input:focus,
textarea:focus {
    outline: none; /** For Safari, etc **/
    border: transparent;
}
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.premium {
    border: 1px solid #FF7676;
}
.viewcard {
  border: 1px solid #dddfe5;
  border-radius: 5px;
  background-color: #ffffff;
}
#profImage{
  width: 70px;
  height: 70px;
  line-height: 65px;
}
.trendingg {
    background-color: #D9DCE1;
    margin-bottom: -1px;
    border-radius: 4px 0 0 5px;
}
.fittocenter {
    margin: auto;
}
.vline {
    border-left: 1px solid #dddfe5;
    margin-top: 5px;
    margin-bottom: 5px;
}
.navicon {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    margin: auto;
}
nav ul li a {
    padding: 0.5rem .5rem;
}
nav ul li .maintab{
    padding: 0.5rem 1rem;
}
.followbtn {
    border: none;
    background-color: rgba(31, 31, 31,.04);
}
.viewprofimg {
    width: 70px;
    height: 70px;
    border: 2px solid grey;
    border-radius: 50%;
}
.mobviewItems {
    overflow-x: auto;
}
@media only screen and (max-width: 600px) {
 #followImage{
        width: 30px;
        height: 30px;
    }
}
@media screen and (max-width: 600px) {     
   .no-video {
        width: 70%;
        align-self: center;
    }
    .pageloader {
        width: 15%;
        margin-left: 42%;
    }
}
@media screen and (min-width: 350px) and (max-width: 400px) {
    nav ul li a {
        display: block;
        padding: 0.5rem 0.8rem !important;
        color: grey;
        text-decoration: none;
        display: block;
        flex: 0 1 auto;
        list-style-type: none;
        /* background: #fafafa; */
        font-size: 10px;
        max-width: 200px;
    }
    #followImage{
        width: 15px;
        height: 15px;
        transform: scale(1.6)  !important;
    /* border: 1px solid black; */
    }
}
@media screen and (min-width: 300px) and (max-width: 400px) {
    nav ul li a{
        padding: 0.5rem 0.5rem;
    }
}

@media screen and (min-width: 900px) and (max-width: 1100px) {
    
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
  .mobviewItems{
    overflow: auto;
  }
  .pageloader {
        width: 10%;
        margin-left: 44%;
    }
}
@media screen and (min-width: 900px) and (max-width: 1295px) {
    #followImage{
        width: 25px;
        height: 25px;
        transform: scale(1.2)  !important;
        border: 1px solid #1F1F1F;
    }   
}
</style>
